module.exports = __webpack_public_path__ + "img/avatar-1.b71a3e78.png";